import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import type { ProjectStatusOutput } from "@/types";

type Params = {
  account_id: string;
  role: string;
};

export function useProjectStatus(params: Params) {
  const query = buildParams(params);

  return useQuery({
    queryKey: ["project-status", params],
    queryFn: () => apiFetch<ProjectStatusOutput>(`/v1/home/project-status${query}`),
    enabled: true, // TODO: remove when API is ready
  });
}
